import { Routes } from '@angular/router';
import { environment } from '../environments/environment';

export const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  {
    path: 'inicio',
    loadComponent: () => import('./selecctor/selecctor').then((m) => m.Selecctor),
    title: environment.appTitle + ' - Inicio | Aceptación de términos y cargue de documentos',
  },
  {
    path: 'inicio/:stringID',
    loadComponent: () => import('./selecctor/selecctor').then((m) => m.Selecctor),
    title: environment.appTitle + ' - Inicio | Aceptación de términos y cargue de documentos',
  },
];
